import { h as hasOwnProperty } from '../../LocalModules/storm-ui-utils/dist/esm/hasOwnProperty-88441d0a-c5bc8a2b.js';

const isClickableListItem = item => !!(hasOwnProperty(item, 'type') && hasOwnProperty(item.type, 'displayName') && typeof item.type.displayName === 'string');
var isClickableListItem$1 = isClickableListItem;

export { isClickableListItem$1 as i };
//# sourceMappingURL=isClickableListItem-626ce8b0.js.map
